var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8507 75.6109V41.1807H24.4067V75.6109H35.8507ZM30.1287 36.4798C34.1194 36.4798 36.6033 33.8359 36.6033 30.5319C36.5289 27.1535 34.1194 24.583 30.2044 24.583C26.2897 24.583 23.7302 27.1535 23.7302 30.5319C23.7302 33.8359 26.2136 36.4798 30.0541 36.4798H30.1284H30.1287Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.183 75.6109H53.6268V56.3836C53.6268 55.3546 53.7012 54.3266 54.0034 53.591C54.8307 51.535 56.7137 49.4057 59.8751 49.4057C64.0161 49.4057 65.6727 52.563 65.6727 57.1915V75.6109H77.1156V55.8691C77.1156 45.2937 71.4698 40.3727 63.9405 40.3727C57.7669 40.3727 55.0566 43.8235 53.5507 46.1739H53.6272V41.1807H42.1833C42.3335 44.4114 42.1833 75.6109 42.1833 75.6109H42.183Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.9d7d28d88982aae802b451ba31ac1502.svg";
export { ForwardRef as ReactComponent };